
    import Vue from 'vue';
    import {mask} from 'vue-the-mask';
    import vuex from '@/store';
    import {mapMutations, mapState} from 'vuex';
    //store
    import UnitPlan from '@/store/units/UnitPlan';
    import UnitPlanPreLearning from '@/store/planner/purpose/UnitPlanPreLearning';
    import UnitPlanSkill from '@/store/planner/purpose/UnitPlanSkill';
    import UnitPlanAttitude from '@/store/planner/purpose/UnitPlanAttitude';
    import _ from "lodash";

    // Models
    import School from "../../store/commons/School";

    export default Vue.extend({
    name: 'RomaOrganizer',
    created(): void {
        this.getFilters();
        this.unsubscribe = this.$store.subscribe((mutation, state) => {            
          if(mutation.type == 'appLoading'){
            this.selectedSubject = this.$store.state.unitList.paginator.filter.subject;
            if(this.$store.state.unitList.paginator.filter.level != -1 && this.$store.state.unitList.paginator.filter.level != undefined){
              this.selectedLevel = this.levelFilters.find(level => level.id === this.$store.state.unitList.paginator.filter.level)
            }
            this.selectedCourse = this.$store.state.unitList.paginator.filter.course;
          };          
        })
    },
    beforeDestroy(){      
      this.unsubscribe();
    },
    props: {
       schoolId: {
            type: Number,
            required: true,
        },
        expanded: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            unsubscribe: null,
            userPrivileges: this.$store.state.user.privileges,
            mask: '###',
            isExpanded: 0,
            defaultStatus: {
              description:'',
              id: {
                idEstadoEdicion:-1,
                idEstadoPlan:-1
              }
            },
            selectedInstitution: -1,
            selectedPlan: -1,
            selectedSubject: -1,
            selectedLevel: -1,
            selectedCurse: -1,
            selectedCourse:'',
            selectedUnit: -1,
            selectedStatus: -1,
            selectedTeacher: -1,
            selectedYear: -1,
            percentage: -1,
            institutionFilters: null,
            planeFilters: null,
            subjectFilters: [],
            levelFilters: [],
            courses: [],
            courseFilters: null,
            courseNames: [],
            unitsFilters: null,
            statusFilters: null,
            teacherFilters: [],
            yearsFilters: [],
            isActive: true,
            pie: false,
            puName: "",
        };
    },
    watch: {
      selectedYear(val, oldVal) {
        this.courseFilters = [];
        let coursess = [];
        coursess = this.courses.filter( (seccion:any) => seccion.periodo == this.selectedYear );
        this.selectedCourse = '';
        Object.values(_.groupBy( coursess, 'educacion')).map(
          (educacion) => {
            if(educacion.length){
              this.courseFilters.push({header: educacion[0].educacion});
              educacion.forEach( (course: any) => {
                this.courseFilters.push({id: course.id, name: course.nombre});
              });
            }            
          }
        );        
      }

    },
    computed: {
        school: {
            get() {
                const index = this.$store.state.organizer.selectedSchool? this.$store.state.organizer.selectedSchool.id : 0;
                return School.find(index);
            },
            set(school) {
                this.$store.commit('selectSchool', school);
            },
        },
        puNameToShow: {
            get() { return this.puName === "" ? '' : this.puName; },
            set(value) { this.puName = value; }
        },
        percentageToShow: {
          get() { return this.percentage === -1 ? '' : this.percentage; },
          set(value) { this.percentage = value; }
        },
        ...mapState(['unitList']),
    },
    methods: {
        ...mapMutations(['appLoading']),
        getCountUnitPlan(): number {
          return UnitPlan.query()
                  .where('school_id', this.schoolId)
                  .count();
        },
        removeFilters(){
            this.selectedInstitution = -1;
            this.selectedPlan = -1;
            this.selectedSubject = -1;
            this.selectedLevel = null;
            this.selectedCurse = -1;
            this.selectedCourse = '';
            this.selectedUnit = -1;
            this.selectedStatus = this.defaultStatus;
            this.selectedTeacher = -1;
            this.percentage = -1;
            this.puName = '';
            this.selectedYear = -1;
            this.search();
        },
        search () {
            this.$store.state.unitList.paginator.page = 1; // Siempre buscar desde la pagina 1
            const idInstitucion = this.userPrivileges.canFilterByInstitution ? this.selectedInstitution : this.$store.state.user.institution.id;
            let idEstadoEdicion;
            let idEstadoPlan;

            if (this.selectedStatus && this.selectedStatus.id) {
              idEstadoEdicion = this.selectedStatus.id.idEstadoEdicion;
              idEstadoPlan = this.selectedStatus.id.idEstadoPlan;
            } else {
              idEstadoEdicion = -1;
              idEstadoPlan = -1;
            }

            if(!this.selectedYear){
              this.selectedYear = -1;
            }
            if(!this.selectedCourse){
              this.selectedCourse=null;
            }
            
            const idCategoria = this.selectedLevel && this.selectedLevel != -1 ? this.selectedLevel.id : -1;
            const percentage = this.percentage ? this.percentage : -1;
            const params = `idInstitucion=${idInstitucion}&idPlanAnual=${this.selectedPlan}&idAsignatura=${this.selectedSubject}&idCategoria=${idCategoria}&courseName=${this.selectedCourse}&idUnidad=${this.selectedUnit}&idEstadoEdicion=${idEstadoEdicion}&idEstadoPlan=${idEstadoPlan}&idPersona=${this.selectedTeacher}&porcentajeAvanceCurricular=${percentage}&page=${this.unitList.paginator.page}&itemsPerPage=${this.unitList.paginator.itemsPerPage}&isActive=${this.isActive}&pie=${this.pie}&puName=${this.puName}&year=${this.selectedYear}`;
            // set filtros en vuex para la paginación de plan unidad
            this.$store.state.unitList.paginator.filter.institution = idInstitucion;
            this.$store.state.unitList.paginator.filter.plan = this.selectedPlan;
            this.$store.state.unitList.paginator.filter.subject = this.selectedSubject;
            this.$store.state.unitList.paginator.filter.level = idCategoria;
            this.$store.state.unitList.paginator.filter.course = this.selectedCourse ? this.selectedCourse : -1 ;
            this.$store.state.unitList.paginator.filter.courseName = this.selectedCourse;
            this.$store.state.unitList.paginator.filter.unit = this.selectedUnit;
            this.$store.state.unitList.paginator.filter.editionStatus = idEstadoEdicion;
            this.$store.state.unitList.paginator.filter.planStatus = idEstadoPlan;
            this.$store.state.unitList.paginator.filter.teacher = this.selectedTeacher;
            this.$store.state.unitList.paginator.filter.percentage = percentage;
            this.$store.state.unitList.paginator.filter.isActive = this.isActive;
            this.$store.state.unitList.paginator.filter.pie = this.pie;
            this.$store.state.unitList.paginator.filter.puName = this.puName;
            this.$store.state.unitList.paginator.filter.years = this.selectedYear;

            this.$emit('search-anual-plans');
            /*
            vuex.dispatch('getUnitPlans', request).then(data => {
                // Paginador
                this.$store.state.unitList.paginator.lastPage = data.data.content.lastPage;

                UnitPlan.deleteAll();
                // Proposito
                UnitPlanPreLearning.deleteAll();
                UnitPlanSkill.deleteAll();
                UnitPlanAttitude.deleteAll();

                if (data.data.content.data.length > 0) {
                  data.data.content.data.forEach(uniplan => {
                    // Educación para poder ordenar por educación media y básica
                        uniplan.educationLevel = uniplan.nivel.substring(uniplan.nivel.lastIndexOf('°') + 1).trim();
                        // Campos de nivel y sección por separado
                        uniplan.level = uniplan.nivel;
                        uniplan.course = uniplan.seccion;
                        uniplan.year = uniplan.nombre_plan;
                        UnitPlan.insertOrUpdate({data: uniplan});
                    });
                    this.appLoading(false);
                } else {
                  this.appLoading(false);
                }
            }).catch(errors => {
                this.appLoading(false);
            });
            */
        },
        getFilters () {
            this.appLoading();
            this.$store.dispatch('romaForFilter').then(response => {
                this.institutionFilters = response.data.content.instituciones;
                this.planeFilters = response.data.content.periodos;
                this.subjectFilters = response.data.content.asignaturas;
                this.levelFilters = [];
                response.data.content.educacionList.forEach(education => {
                  this.levelFilters.push({header: education.name});
                  education.categorias.forEach(level => {
                    this.levelFilters.push({id: level.id, name: level.name});
                  });
                });
                let setCourses = new Set();
                response.data.content.secciones.map((course:any) => setCourses.add(course.nombre));
                this.courseNames = [...setCourses].sort();

                this.unitsFilters = response.data.content.unidades;
                this.statusFilters = response.data.content.estados;
                this.teacherFilters = response.data.content.profesores;
                this.yearsFilters = response.data.content.years;
                this.$store.state.unitList.paginator.filter.yearsArray = response.data.content.years;

                // Seleccionamos filtros marcados
                this.selectedInstitution = this.$store.state.unitList.paginator.filter.institution;           
                /*
                this.selectedPlan = this.$store.state.unitList.paginator.filter.plan;
                this.selectedSubject = this.$store.state.unitList.paginator.filter.subject;
                this.selectedLevel = this.$store.state.unitList.paginator.filter.level === -1 ? -1 : this.levelFilters.find(level => level.id === this.$store.state.unitList.paginator.filter.level);
                this.selectedCurse = -1;
                this.selectedCourse = this.$store.state.unitList.paginator.filter.courseName;
                this.selectedUnit = this.$store.state.unitList.paginator.filter.unit;
                if (this.$store.state.unitList.paginator.filter.editionStatus > -1 && this.$store.state.unitList.paginator.filter.planStatus > -1) {
                  const idEstadoEdicion = this.$store.state.unitList.paginator.filter.editionStatus;
                  const idEstadoPlan = this.$store.state.unitList.paginator.filter.planStatus;
                  this.selectedStatus = this.statusFilters.find(status => status.id && status.id.idEstadoEdicion === idEstadoEdicion && status.id.idEstadoPlan === idEstadoPlan);
                } else {
                  this.selectedStatus = -1;
                }
                this.selectedTeacher = this.$store.state.unitList.paginator.filter.teacher;
                this.pie = this.$store.state.unitList.paginator.filter.pie;
                this.puName = this.$store.state.unitList.paginator.filter.puName;
                */
                this.isActive = this.$store.state.unitList.paginator.filter.isActive;
                this.courses = response.data.content.secciones; 
                this.selectedYear = this.school.yearSelected;
                this.appLoading(false);
                this.search();
            });
        },
    },
    directives: {
        mask
    }
});
